import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { constants } from '../../constants';
import { IfStmt } from '@angular/compiler';
import { CommonUtilitiesService } from '../../common-utilities.service';
import { FilterFourService } from './filter-four.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filter-four',
  templateUrl: './filter-four.component.html',
  styleUrls: ['./filter-four.component.scss'],
  providers: [FilterFourService]
})
export class FilterFourComponent implements OnInit {

  public CARE_CHANNELS_TITLE: string = this.LANG.getLangText("CARE_CHANNELS_FOOTER_TITTLE_GENERIC");
  form: FormGroup
  tecnologies = []
  roads = []
  regions = []
  isLoadingBalance = false;
  butDisabled:boolean = true;
  optionsSelected = []

  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;
 

  @Output() dataFilter = new EventEmitter<any>();


  constructor(
    private formbuilder: FormBuilder,
    private _router: Router, 
    public LANG: CommonUtilitiesService,
    private filterFourService:FilterFourService
  ) { }

  ngOnInit() {

    this.form = this.formbuilder.group({
      techSelec: [''],
      roadSelec: ['']
    });
    //get tecnologies
    this.get_technology_coverage_list()
  }

  // this.LANG.getLangText('URL_PATH_KML')

  /**
   * Description: Método que llama el servicio web de obtener todas las tecnologiaS
   * Autor: Luis Hernandez
   * @return Tecnologies
   */
  get_technology_coverage_list(){
    this.isLoadingBalance = true;
    this.filterFourService.get_technology_coverage_list().subscribe(technologys => {
      technologys["obj"].forEach(element => {
          if(element.name != "4G-LTE"){
            this.tecnologies.push(element)
          }
      });
      
      this.isLoadingBalance = false;
    });
  }


  /**
   * Description: Método que llama el servicio web de obtener todas las carreteras segun la tecnologia
   * Autor: Luis Hernandez
   * @param technology tecnologia a consultar
   * @return Carreteras
   */
  get_road_coverage(){
    this.isLoadingBalance = true;
    this.filterFourService.get_road_coverage(this.form.get('techSelec').value).subscribe(roads => {
        this.roads = roads["obj"]
        this.isLoadingBalance = false;
    });
  }


  /**
   * Description: Método que llama el servicio web para obtener todas la regiones de una carretera en especifico
   * Autor: Luis Hernandez
   * @param technology tecnologia a consultar
   * @param road carretera a consultar
   * @return Regiones
   */
  get_coverage_road_technology(){


    if(this.form.get('roadSelec').value != "" && this.form.get('techSelec').value != ""){

      this.regions = []
      this.regions.push({
        "filter":4,
        "data":[],
        "type":this.form.get('techSelec').value
      })

      this.isLoadingBalance = true;
      this.filterFourService.get_coverage_road_technology(this.form.get('techSelec').value, this.form.get('roadSelec').value).subscribe(regions => {
          let response = regions["obj"]
          const regionsArray = response.regions.split("/");
          this.regions[0].data.push(this.LANG.getLangText('URL_PATH_KML')+"CARRETERAS/"+this.form.get('roadSelec').value+"/"+this.form.get('techSelec').value+"/predictions.kml")
          regionsArray.forEach(region => {
            this.regions[0].data.push(this.LANG.getLangText('URL_PATH_KML')+region+"/"+this.form.get('techSelec').value+"/predictions.kml")
          });
          this.dataFilter.emit(this.regions)
          this.isLoadingBalance = false;
      });
    }else{
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      this.isLoadingBalance = false;
    }


  }



  /**
   * Description: Método que ocualta el modal
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    } 
  }


}
